export const CardConfirmed = new Event('organisation_card_confirmed');
export const SideBarEvent  = new Event('sidebar');
export const TriggerFilter = new Event('trigger_filter');
